import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const images = document.querySelectorAll('.js-clip-pax');
const offsetPercent = 10;

function imageLoaded(e) {
  const img = e.target;
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: img,
      scrub: 1,
    },
  });
  tl.fromTo(img,
    { clipPath: `polygon(0% ${ offsetPercent }%, 100% ${ offsetPercent }%, 100% 100%, 0% 100%)` },
    { clipPath: `polygon(0% 0%, 100% 0%, 100% ${ 100 - offsetPercent }%, 0% ${ 100 - offsetPercent }%)` });
}

images.forEach((img) => {
  img.addEventListener('load', imageLoaded);
});
